import { BugoData } from '@shared/api/bugo/bugo.interface';
import { GiftItemForStore } from '@shared/api/giftItem/giftItem.interface';
import { GiftItemInfoType } from '@shared/api/giftItemInfo/giftItemInfo.interface';
import {
  BulkDeliveryAddress,
  GiftOrderCreateDto,
  GiftOrderDeliveryMode,
  GiftOrderItemCreateDto,
} from '@shared/api/giftOrder/giftOrder.interface';

interface OrderItemInput {
  giftItem: GiftItemForStore;
  quantity: number;
}

interface IParams {
  bugo: BugoData;
  receiverName: string;
  receiverPhoneNumber: string;
  items: OrderItemInput[];
  deliveryMode?: GiftOrderDeliveryMode;
  bulkDeliveryAddress?: BulkDeliveryAddress;
}

/**
 * 다중 상품 GiftOrder DTO 생성 (백엔드 스펙 v2)
 */
export const getGiftOrderDto = ({
  bugo,
  receiverName,
  receiverPhoneNumber,
  items,
  deliveryMode,
  bulkDeliveryAddress,
}: IParams): GiftOrderCreateDto => {
  const totalPrice = items.reduce((sum, item) => {
    const priceRetail = item.giftItem.priceRetail || 0;
    return sum + priceRetail * item.quantity;
  }, 0);

  const taxableAmount = items.reduce((sum, item) => {
    const isTaxable = item.giftItem.giftItemInfo?.isTaxable ?? false;
    if (!isTaxable) return sum;
    const priceRetail = item.giftItem.priceRetail || 0;
    return sum + priceRetail * item.quantity;
  }, 0);
  const taxFreeAmount = totalPrice - taxableAmount;
  const vatAmount = Math.round(taxableAmount / 11);

  const orderDetails: GiftOrderItemCreateDto[] = items.map((item) => {
    const isCouponType = item.giftItem.giftItemInfo?.type === GiftItemInfoType.Coupon;

    const orderDetail: GiftOrderItemCreateDto = {
      giftItem: item.giftItem._id,
      quantity: item.quantity,
    };

    if (isCouponType) {
      orderDetail.couponDetail = { totalCount: item.quantity };
    }

    return orderDetail;
  });

  return {
    bugo: bugo._id,
    receiverName,
    receiverPhoneNumber,
    deliveryMode,
    bulkDeliveryAddress,
    orderDetails,
    paymentDetail: {
      paymentByCash: totalPrice,
      taxFreeAmount,
      taxableAmount,
      vatAmount,
      paymentByPoint: 0,
    },
    webBaseUrl: process.env.REACT_APP_WEB_BASE_URL,
  };
};

/**
 * 단일 상품용 간편 DTO 생성 (바로구매용)
 */
export const getGiftOrderDtoSingle = ({
  giftItem,
  bugo,
  quantity,
  receiverName,
  receiverPhoneNumber,
  deliveryMode,
  bulkDeliveryAddress,
}: {
  giftItem: GiftItemForStore;
  bugo: BugoData;
  quantity: number;
  receiverName: string;
  receiverPhoneNumber: string;
  deliveryMode?: GiftOrderDeliveryMode;
  bulkDeliveryAddress?: BulkDeliveryAddress;
}): GiftOrderCreateDto => {
  return getGiftOrderDto({
    bugo,
    receiverName,
    receiverPhoneNumber,
    deliveryMode,
    bulkDeliveryAddress,
    items: [{ giftItem, quantity }],
  });
};
